document.querySelectorAll('[data-cset]').forEach(function(sec){
  var btns=sec.querySelectorAll('button[data-set]');
  btns.forEach(function(b){b.addEventListener('click',function(){
    var c=b.dataset.set;
    btns.forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false')});
    sec.querySelectorAll('img.cs').forEach(function(i){var on=i.dataset.c===c;i.classList.toggle('on',on);if(on){i.loading='eager';i.removeAttribute('aria-hidden')}else i.setAttribute('aria-hidden','true')});
  })});
  // warm the other set after idle so the swap is instant
  (window.requestIdleCallback||setTimeout)(function(){sec.querySelectorAll('img.cs:not(.on)').forEach(function(i){i.loading='eager'})});
});